/* istanbul ignore file */
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { PlayerLayout } from '@/components/layout/player/PlayerLayout';
import { ProtectedVideoRoute } from '@/components/routes/ProtectedVideoRoute';
import { PitchSelectVideoPreview as PlayerPitchVisVideoPreview } from '@/components/video/PitchSelectVideoPreview';
import { NotFound } from '@/pages/NotFound';
import { PlayerDashboardPage } from '@/pages/player/dashboard/PlayerDashboardPage';
import { PlayerDashboardSummaryPanel } from '@/pages/player/dashboard/PlayerDashboardSummaryPanel';
import { PlayerGamesPage } from '@/pages/player/games/PlayerGamesPage';
import { PlayerGamesVideoPreview } from '@/pages/player/games/video/PlayerGamesVideoPreview';
import { PlayerPreview } from '@/pages/player/preview/PlayerPreview';
import { PlayerRadarPage } from '@/pages/player/radar/PlayerRadarPage';
import { PlayerVisPage } from '@/pages/player/vis/PlayerVisPage';

export const PlayerRoutes = () => (
  <Routes>
    <Route element={<PlayerLayout />}>
      <Route path="dashboard" element={<PlayerDashboardPage />}>
        <Route path="summary" element={<PlayerDashboardSummaryPanel />} />
      </Route>
      <Route path="radar" element={<PlayerRadarPage />}>
        <Route path="preview" element={<PlayerPreview />} />
      </Route>
      <Route path="vis" element={<PlayerVisPage />}>
        <Route path="preview" element={<ProtectedVideoRoute component={<PlayerPitchVisVideoPreview />} />} />
      </Route>
      <Route path="matches" element={<PlayerGamesPage />}>
        <Route path="video/preview" element={<ProtectedVideoRoute component={<PlayerGamesVideoPreview />} />} />
      </Route>
    </Route>
    <Route path="*" element={<NotFound />} />
  </Routes>
);
